module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/addressing_mobile-916641f96f87fb607ea7bf8b748c0655.png";